import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { RepresentativeDto } from '../../../../../shared/models/auth.interfaces'

@Component({
    selector: 'app-dashboard-layout-topbar-user',
    templateUrl: './dashboard-layout-topbar-user.component.html',
    styleUrls: ['./dashboard-layout-topbar-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardLayoutTopbarUserComponent {
    @Input() representative!: RepresentativeDto | null

    get fullname(): string {
        return `${this.representative?.name} ${this.representative?.surname}`
    }

    get shortName(): string {
        return `${this.representative?.name.charAt(0)}${this.representative?.surname.charAt(0)}`
    }
}
